import { Trans } from 'react-i18next'

import {
  ANSWERS,
  RECOMMENDATION_QUESTION,
  greenAccept,
  redCross,
} from '~/pages/anatomy/quizBinaryChoice/libs/constants'
import { Styles as S } from '~/pages/anatomy/quizBinaryChoice/libs/styles'
import { useBinaryChoiceStep } from '~/shared/hooks/useBinaryChoiceStep'
import { TPageProps } from '~/shared/types/commonTypes'

const RecommendationAnatomy = ({ pageId, nextPagePath }: TPageProps) => {
  const { answer, handleAnswer } = useBinaryChoiceStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: RECOMMENDATION_QUESTION,
  })

  return (
    <S.Root>
      <S.StyledContainer>
        <S.Question>
          <Trans i18nKey="onboarding.quizBinaryChoice.recommendationTitle" />
        </S.Question>

        <S.ButtonWrapper>
          <S.StyledButton
            type="button"
            $isSelected={answer === ANSWERS.no}
            onClick={() => handleAnswer(ANSWERS.no)}
          >
            <S.ButtonIcon src={redCross} alt={ANSWERS.no} />
            <Trans i18nKey={`actions.${ANSWERS.no}`} />
          </S.StyledButton>

          <S.StyledButton
            type="button"
            $isSelected={answer === ANSWERS.yes}
            onClick={() => handleAnswer(ANSWERS.yes)}
          >
            <S.ButtonIcon src={greenAccept} alt={ANSWERS.yes} />
            <Trans i18nKey={`actions.${ANSWERS.yes}`} />
          </S.StyledButton>
        </S.ButtonWrapper>
      </S.StyledContainer>
    </S.Root>
  )
}

export default RecommendationAnatomy
